import { render, staticRenderFns } from "./select_question.vue?vue&type=template&id=fab3567c&scoped=true&"
import script from "./select_question.vue?vue&type=script&lang=js&"
export * from "./select_question.vue?vue&type=script&lang=js&"
import style0 from "./select_question.vue?vue&type=style&index=0&id=fab3567c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fab3567c",
  null
  
)

export default component.exports